/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {useIsPhone} from '@ion/dls/src/hooks/useMedia';

/**
 * Provides a utility hook for determining whether or not to show user profile view.
 * Note, this hook requires applications to have a nav reducer with isUserProfileView
 * state.
 *
 * ```typescript
 *
 *   import {useShowProfile} from '@ion/applications/src/hooks/useShowProfile';
 *
 *   const SomeComponent = () => {
 *     const showProfile = useShowProfile();
 *     if (showProfile) {
 *       ...
 *     }
 *   }
 *
 * ```
 */
export const useShowProfile = () => {
  const isPhone            = useIsPhone();
  const isUserProfileView  = useSelector(({nav}: any) => nav.isUserProfileView);
  return (isPhone && isUserProfileView);
};
export default useShowProfile;
